//h dialog
import store from "./assets/js/store"
import vueHawesomeModal from "vue-hawesome-modal"
import "vue-hawesome-modal/dist/vue-hawesome-modal.css"
import "../src/assets/css/materialdesignicons.min.css"

import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import i18n from './i18n'
import router from './router/router'
import api from './services/index'
import globalVar from './global_vars'
import globalFunc from './global_func'
import Moment from 'moment'
import DialogLoader from './components/dialogLoader'
import VueClipboard from 'vue-clipboard2';

import './assets/css/style.css'

Vue.use(VueClipboard);

//清空缓存
localStorage.removeItem('account')
localStorage.removeItem('token')

Vue.config.productionTip = false
Vue.prototype.globalVar = globalVar
Vue.use(globalFunc)

// 定义全局时间戳过滤器
Vue.filter('formatDate', function(value) {
  return Moment(value).format('YYYY-MM-DD')
})

// 定义全局时间戳过滤器
Vue.filter('formatTime', function(value) {
  return Moment(value).format('HH:mm:ss')
})

//全局注册loading组件
Vue.use(DialogLoader)

// initialize global settings
var options = { 
  store, 
  themeColor: "#222222",
  dialogSetting: {  title: i18n.locale == 'en' ? "Notice":"提示", confirmBtnTxt: i18n.locale == 'en' ? "Confirm":"确定", confirmBtnColor: '#0090FFFF', cancelBtnTxt: i18n.locale == 'en' ? "Cancel":"取消", withOverlay: true, outerWidth: 500, titleBarColor: '#FFA000FF' },
  notifySetting: { position: "topRight", timeout: 3 , width: 600},
  loaderSetting: { type: "linear", loaderText: "加载中..." }
}

// install
Vue.use(vueHawesomeModal, options)

router.beforeEach((to, from, next) => {
  if(to.meta.title) {
    document.title = to.meta.title
  }

  next()
})


new Vue({
  store,
  vuetify,
  i18n,
  api,
  router,
  render: h => h(App)
}).$mount('#app')

localStorage.setItem('language', 'zh-cn')
// localStorage.setItem('language', 'en')
i18n.locale = 'zh-cn'

